import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import TYPOGRAPHY from '../../themes/Typography'
import COLORS from '../../themes/Colors'
import METRICS from '../../themes/Metrics'
import { px2Rem } from '../../themes/Mixins'

// Defined component Description
const Description = ({ text, customStyle, ...props }) => {
  return (
    <p
      type='text'
      className={props.className}
      style={customStyle}
    >
      {text}
    </p>
  )
}

// Defined styled component for Description
export default styled(Description) `
  font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.light};
  letter-spacing: normal;
  text-align: ${props => props.align || 'left'}

  ${props => props.type === 'xxTiny' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xxTiny};
    color: ${props => props.color || COLORS.lighterGray};
  `};

  ${props => props.type === 'xxxTiny' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xxxTiny};
    font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.bold};
    color: ${props => props.color || COLORS.descriptionGame};
    margin-top: ${px2Rem(13)};
  `};

  ${props => props.type === 'small' && css`
    font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.light};
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xxTiny};
    color: ${props => props.color || COLORS.white};
  `};

  ${props => props.type === 'xTiny' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xTiny};
    color: ${props => props.color || COLORS.lighterGray};
  `};

  ${props => props.type === 'xSmall' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xTiny};
    font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.bold};
    color: ${props => props.color || COLORS.descriptionGame};
  `};

  ${props => props.type === 'base' && css`
    font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.light};
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xTiny};
    color: ${props => props.color || COLORS.white};
  `};

  ${props => props.type === 'tiny' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.tiny};
    color: ${props => props.color || COLORS.lighterGray};
  `};

  ${props => props.type === 'xxSmall' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.small};
    font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.light};
    color: ${props => props.color || COLORS.white};
  `};

  ${props => props.type === 'medium' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.medium};
    color: ${props => props.color || COLORS.white};
    font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.normal};
    padding: ${props => props.padding || METRICS.descPadding};
  `};

  ${props => props.type === 'xxLarge' && css`
    font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xxLarge};
    color: ${props => props.color || COLORS.red};
  `};
`

Description.propTypes = {
  text: PropTypes.string
}

Description.defaultProps = {
  text: ''
}



// WEBPACK FOOTER //
// ./src/components/common/Description.js